import React, { useState, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import Button from 'react-bootstrap/esm/Button';
import FormCustom from '../../Components/Form/FormCustom';
import Input from '../../Components/Form/Input';

const ReportePiezasNoProducidas = _ => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState([])

    const [dataFilter, setDataFilter] = useState({
        p_date_start: Helpers.date.get({ format: '%Y-%m-%d', addDays: -7 }),
        p_date_end: Helpers.date.get({ format: '%Y-%m-%d' })
    })

    const [reporte, setReport] = useState({})

    const getData = _ => {
        setIsProccesing(true)
        Controllers.document.piezas_no_producidas({
            ...dataFilter
        }).then(res => {
            setRows(res.data.records)
            setReport({
                excel: res.data.excel.file,
                filename: res.data.excel.filename,
            })
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_document', text: 'Documento', align: 'center' },
                { name: 'name_branch_office', text: 'Sucursal', align: 'center', render: r => {
                    return `${r.key_branch_office} - ${r.name_branch_office}`
                } },
                { name: 'Producto', text: 'Materia Prima', align: 'center', render: r => {
                    return `${r.key_product} - ${r.name_product}`
                } },
                { name: 'qty', text: 'Cantidad', align: 'center' },
                { name: 'code_product_unit', text: 'Un. Medida', align: 'center' },
            ],
        ]}
        rows={rows}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Piezas no producidas</span>
            </Card.Header>
            <Card.Body>
                <FormCustom viewSubmit={false} className="mb-3" onSubmit={_ => {
                    getData()
                }}>
                    <Input
                        classNameParent="col-6 col-md-4 mb-2"
                        icon="far fa-calendar"
                        placeholder="Fecha Inicio"
                        text="Fecha Inicio"
                        onChange={e => setDataFilter({ ...dataFilter, p_date_start: e.currentTarget.value })}
                        required
                        type="date"
                        value={dataFilter.p_date_start}
                    />
                    <Input
                        classNameParent="col-6 col-md-4 mb-2"
                        icon="far fa-calendar"
                        placeholder="Fecha Fina"
                        text="Fecha Fina"
                        onChange={e => setDataFilter({ ...dataFilter, p_date_end: e.currentTarget.value })}
                        append={[<Button type="submit">
                            <i className="fa fa-search mr-2"></i>Buscar
                        </Button>]}
                        required
                        type="date"
                        value={dataFilter.p_date_end}
                    />
                </FormCustom>
                {reporte?.filename ? <div className='mb-4'>
                    <a href={reporte?.excel} download={reporte?.filename}>
                        <Button size="sm" variant="success">
                            <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                        </Button>
                    </a>
                </div> : ''}
                {dtRows}
            </Card.Body>
        </Card>
    </>
}

export default ReportePiezasNoProducidas